import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import { deviceAction } from './deviceSlice';

import * as deviceApiLib from '../lib/deviceApi';

function* deviceList({ payload }) {
  try {
    const deviceList = yield call(deviceApiLib.list, payload);

    yield put(deviceAction.deviceListSuccess({ deviceList }));
  } catch (err) {
    yield put(deviceAction.deviceListFailure('Device List Error'));
  }
}

function* deviceInfo({ payload }) {
  try {
    const deviceInfo = yield call(deviceApiLib.detail, payload);

    yield put(deviceAction.deviceInfoSuccess({ deviceInfo }));
  } catch (err) {
    yield put(deviceAction.deviceInfoFailure('Device Info Error'));
  }
}

function* deviceAdd({ payload }) {
  try {
    yield call(deviceApiLib.add, payload);

    yield put(deviceAction.deviceAddSuccess());
  } catch (err) {
    yield put(deviceAction.deviceAddFailure('Device Add Error'));
  }
}

function* deviceEdit({ payload }) {
  try {
    const deviceInfo = yield call(deviceApiLib.edit, payload);

    yield put(deviceAction.deviceEditSuccess({ deviceInfo }));
  } catch (err) {
    yield put(deviceAction.deviceEditFailure('Device Edit Error'));
  }
}

function* deviceRemove({ payload }) {
  try {
    yield call(deviceApiLib.remove, payload);

    yield put(deviceAction.deviceRemoveSuccess());
  } catch (err) {
    yield put(deviceAction.deviceRemoveFailure('Device Remove Error'));
  }
}

function* deviceCommand({ payload }) {
  try {
    yield call(deviceApiLib.command, payload);

    yield put(deviceAction.deviceCommandSuccess());
  } catch (err) {
    yield put(deviceAction.deviceCommandFailure('Device Command Error'));
  }
}

function* devicePowerUpdate({ payload }) {
  try {
    yield call(deviceApiLib.powerUpdate, payload);

    yield put(deviceAction.devicePowerUpdateSuccess());
  } catch (err) {
    yield put(
      deviceAction.devicePowerUpdateFailure('Device Power Update Error')
    );
  }
}

function* pairing({ payload }) {
  try {
    const pairingInfo = yield call(deviceApiLib.pairing, payload);

    yield put(deviceAction.pairingSuccess({ pairingInfo }));
  } catch (err) {
    yield put(deviceAction.pairingFailure('Pairing Error'));
  }
}

function* pairingUnset({ payload }) {
  try {
    yield call(deviceApiLib.pairingUnset, payload);

    yield put(deviceAction.pairingUnsetSuccess({ deviceList }));
  } catch (err) {
    yield put(deviceAction.pairingUnsetFailure('Pairing Unset Error'));
  }
}

function* scrshotList({ payload }) {
  try {
    const scrshotList = yield call(deviceApiLib.scrshotList, payload);

    yield put(deviceAction.scrshotListSuccess({ scrshotList }));
  } catch (err) {
    yield put(deviceAction.scrshotListFailure('Scrshot List Error'));
  }
}

function* groupMove({ payload }) {
  try {
    yield call(deviceApiLib.groupMove, payload);

    yield put(deviceAction.groupMoveSuccess());
  } catch (error) {
    yield put(deviceAction.groupMoveFailure('Group Move Error'));
  }
}

function* remoteUrl({ payload }) {
  try {
    const remoteUrl = yield call(deviceApiLib.remoteUrl, payload);

    yield put(deviceAction.remoteUrlSuccess({ remoteUrl }));
  } catch (error) {
    yield put(deviceAction.remoteUrlFailure('Remote Url Error'));
  }
}

function* play({ payload }) {
  try {
    yield call(deviceApiLib.play, payload);

    yield put(deviceAction.playSuccess('Play Success'));
  } catch (error) {
    yield put(deviceAction.playFailure('Play Error'));
  }
}

function* stop({ payload }) {
  try {
    yield call(deviceApiLib.stop, payload);

    yield put(deviceAction.stopSuccess('Stop Success'));
  } catch (error) {
    yield put(deviceAction.stopFailure('Stop Error'));
  }
}

export function* watchDeviceList() {
  yield takeLatest(deviceAction.deviceList, deviceList);
}

export function* watchDeviceInfo() {
  yield takeLatest(deviceAction.deviceInfo, deviceInfo);
}

export function* watchDeviceAdd() {
  yield takeLatest(deviceAction.deviceAdd, deviceAdd);
}

export function* watchDeviceEdit() {
  yield takeLatest(deviceAction.deviceEdit, deviceEdit);
}

export function* watchDeviceRemove() {
  yield takeLatest(deviceAction.deviceRemove, deviceRemove);
}

export function* watchDeviceCommand() {
  yield takeLatest(deviceAction.deviceCommand, deviceCommand);
}

export function* watchDevicePowerUpdate() {
  yield takeLatest(deviceAction.devicePowerUpdate, devicePowerUpdate);
}

export function* watchPairing() {
  yield takeLatest(deviceAction.pairing, pairing);
}

export function* watchPairingUnset() {
  yield takeLatest(deviceAction.pairingUnset, pairingUnset);
}

export function* watchScrshotList() {
  yield takeLatest(deviceAction.scrshotList, scrshotList);
}

export function* watchGroupMove() {
  yield takeLatest(deviceAction.groupMove, groupMove);
}

export function* watchRemoteUrl() {
  yield takeLatest(deviceAction.remoteUrl, remoteUrl);
}

export function* watchPlay() {
  yield takeLatest(deviceAction.play, play);
}

export function* watchStop() {
  yield takeLatest(deviceAction.stop, stop);
}

function* rootSaga() {
  yield all([
    fork(watchDeviceList),
    fork(watchDeviceInfo),
    fork(watchDeviceAdd),
    fork(watchDeviceEdit),
    fork(watchDeviceRemove),
    fork(watchDeviceCommand),
    fork(watchDevicePowerUpdate),
    fork(watchPairing),
    fork(watchPairingUnset),
    fork(watchScrshotList),
    fork(watchGroupMove),
    fork(watchRemoteUrl),
    fork(watchPlay),
    fork(watchStop),
  ]);
}

export default rootSaga;
